import React, { useEffect, useState } from "react";
import Image from "next/legacy/image";
import { colors } from "../utils/const";
import { styles } from "./page_cover";
import Form from "./Form.jsx";
import { useRouter } from "next/router";
import en from "../../locales/en";
import ar from "../../locales/ar";
import { Box, Button, Typography } from "@mui/material";

export default function PageCover({
  title1,
  title2,
  description,
  img,
  color,
  formType,
  product,
  source,
}) {
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : ar;
  let leftOrRight = locale === "en" ? { right: "0px" } : { left: "0px" };
  const [isLogin, setIsLogin] = useState(false);
  const isContactNow = product === "shopping";
  useEffect(() => {
    if (localStorage.getItem("UT_UI")) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, []);
  return (
    <Box
      sx={styles.container}
      style={{
        backgroundColor: isContactNow ? color : "#D9D9D9",
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: { xs: "200px", md: "300px", lg: "400px" },
          height: { xs: "100px", md: "200px", lg: "300px" },
          position: "absolute",
          top: "0px",
          ...leftOrRight,
          opacity: ".2",
          transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
        }}
      >
        <Image
          src="/decorator.png"
          alt="decorator"
          sizes="100vw"
          style={{ layout: "fill", objectFit: "cover" }}
          layout="fill"
          priority
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: {
            xs: "flex-start",
            lg: "flex-start",
          },
          textAlign: {
            xs: locale === "en" ? "left" : "right",
            lg: locale === "en" ? "left" : "right",
          },
          m: 3,
        }}
      >
        {isContactNow && (
          <Box
            component="img"
            alt="contact now"
            src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-now.png"
            sx={{ maxWidth: "100px" }}
          />
        )}
        <Box
          sx={styles.container}
          // data-aos={locale == "en" ? "fade-right" : "fade-left"}
          data-aos="fade-up"
        >
          <Box
            sx={{
              position: "relative",
              display: "inline-block",
            }}
          >
            <Typography
              variant="h3"
              data-aos="fade-up"
              sx={{
                fontSize: {
                  xs: "35px",
                  // sm: "35px",
                  md: isContactNow ? "30px" : "42px",
                },
                whiteSpace: "pre-wrap",
                fontWeight: "bold",
                color: isContactNow ? "#fff" : "#2D317F",
                pb: 1,
                maxWidth: { md: "550px" },
                lineHeight: 1.5,
              }}
            >
              {title1}
            </Typography>
            <Box
              sx={{
                position: "absolute",
                objectFit:
                  title1 === "Auto" || title1 === "Trucks" || title1 === "Clubs"
                    ? ""
                    : "cover",
                width: "100%",
                height: "5px",
                transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
              }}
              component="img"
              alt="line"
              src="/line.png"
            ></Box>
          </Box>
        </Box>
        <Typography
          variant="h2"
          data-aos="fade-up"
          data-aos-delay="100"
          sx={{
            fontSize: isContactNow ? "15px" : "30px",
            fontWeight: isContactNow ? "initial" : "bold",
            color: isContactNow ? "#fff" : "#2D317F",
            maxWidth: "600px",
          }}
        >
          {title2}
        </Typography>

        <Box
          data-aos="fade-up"
          data-aos-delay="300"
          sx={{
            color: isContactNow ? "rgba(255, 255, 255, 0.7)" : "#404456",
            fontSize: "16px",
            wordWrap: "break-word",
            maxWidth: "600px",
            pb: 2,
            lineHeight: 2,
            textAlign: {
              lg: locale === "en" ? "left" : "right",
            },
          }}
        >
          {description}
        </Box>
        {isContactNow && (
          <Box
            onClick={() => {
              isLogin ? router.push("/contract") : router.push("/login");
            }}
            component={Button}
            sx={{
              backgroundColor: colors.orange,
              color: "#fff",
              transition: ".5s",
              "&:hover": {
                backgroundColor: colors.orange,
                color: "#fff",
                opacity: ".7",
              },
            }}
          >
            {t.contact_now_btn}
          </Box>
        )}
        <Box
          data-aos="fade-up"
          sx={{
            maxWidth: {
              xs: isContactNow ? "300px" : "100%",
              sm: isContactNow ? "300px" : "500px",
            },
            m: { xs: 1, sm: 5 },
            mt: "0px !important",
            transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
          }}
        >
          <Box
            component="img"
            src={img}
            alt="page cover"
            loading="lazy"
            sx={{
              width: "100%",
            }}
          ></Box>
        </Box>
      </Box>
      {/* form ================================================================================ */}
      <Form color={color} type={formType} product={product} source={source} />
    </Box>
  );
}
